<template slot-scope="scope">
  考试列表
  <el-scrollbar max-height="600px">
    <el-button type="success" circle  class="addBtn" @click="addExamForm = true" >
      <el-icon><Plus /></el-icon>
    </el-button>

    <!-- 添加考试 -->
    <el-dialog
    v-model="addExamForm"
    title="添加考试"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="examName" class="col-sm-2 col-form-label">试卷名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="examName"/>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>


      <div class="mb-3 row">
        <label for="startTime" class="col-sm-2 col-form-label">开始</label>
        <div class="col-sm-9">
            <input type="datetime-local" id="startTime" class="form-control" placeholder="选择时间">
            </div>
        <div class="col-sm-1">
          <span style="color: red">
            <span style="color: red">*</span>
          </span>
        </div>
        </div>


        <div class="mb-3 row">
            <label for="stopTime" class="col-sm-2 col-form-label">截止</label>
            <div class="col-sm-9">
                <input type="datetime-local" id="stopTime" class="form-control" placeholder="选择时间">
                </div>
            <div class="col-sm-1">
            <span style="color: red">
                <span style="color: red">*</span>
            </span>
            </div>
        </div>

        <div class="mb-3 row">
            <label for="examTime" class="col-sm-2 col-form-label">时长min</label>
            <div class="col-sm-9">
                <input type="number" id="examTime" class="form-control" min="0" max="1440" placeholder="选择时间">
                </div>
            <div class="col-sm-1">
            <span style="color: red">
                <span style="color: red">*</span>
            </span>
            </div>
        </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="addExamForm = false">取消</el-button>
        <el-button type="submit" @click="addExam();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 修改考试 -->
  <el-dialog
    v-model="editHomeworkForm"
    title="修改考试"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="editHomeworkName" class="col-sm-2 col-form-label">考试名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="editHomeworkName" :value="editHomeworkName"/>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>


      <div class="mb-3 row">
        <label for="examName" class="col-sm-2 col-form-label">开始</label>
        <div class="col-sm-9">
            <input type="datetime-local" id="editStartTime" class="form-control" :value="editStartTime" placeholder="选择时间">
            </div>
        <div class="col-sm-1">
          <span style="color: red">
            <span style="color: red">*</span>
          </span>
        </div>
        </div>
        <div class="mb-3 row">
            <label for="examName" class="col-sm-2 col-form-label">截止</label>
            <div class="col-sm-9">
                <input type="datetime-local" id="editStopTime" class="form-control" :value="editStopTime" placeholder="选择时间">
                </div>
            <div class="col-sm-1">
            <span style="color: red">
                <span style="color: red">*</span>
            </span>
            </div>
            <input type="hidden" id="editHomeworkId" :value="editHomeworkId">
        </div>
        <div class="mb-3 row">
            <label for="editExamTime" class="col-sm-2 col-form-label">时长min</label>
            <div class="col-sm-9">
                <input type="number" id="editExamTime" class="form-control" :value="editExamTime" min="0" max="1440" placeholder="选择时间">
                </div>
            <div class="col-sm-1">
            <span style="color: red">
                <span style="color: red">*</span>
            </span>
            </div>
        </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editHomeworkForm = false">取消</el-button>
        <el-button type="submit" @click="edithomeworkOk();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


  <div class="demo-collapse">
    <el-collapse v-model="activeNames">
        <el-collapse-item :title="homework.examName" :name="homework.examId" v-for="homework in exams" :key="homework.examId">
            <!-- <el-popconfirm
            title="确定暂停作业吗？"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference> -->
            <!-- </template>
          </el-popconfirm> -->


          <el-popconfirm
            title="确定删除考试吗？"
            @confirm="deleteHomework(homework.examId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
                <el-button type="danger" class="addBtn" plain>删除</el-button>
            </template>
          </el-popconfirm>
       


          <el-button type="success" v-if="homework.states == 1" class="addBtn"  plain>已发布</el-button>
          <el-popconfirm
            title="确定发布考试吗？发布考试后状态不能改变！"
            @confirm="changeHomeworkState(homework.examId, 1)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
                <el-button type="info" v-if="homework.states == 0" class="addBtn" plain>未发布</el-button>
            </template>
          </el-popconfirm>
       
          <el-button type="warning" class="addBtn" @click="gotoProblem(homework.examId)" v-if="homework.states == 0" plain>
              题目设置
          </el-button>

          <el-button type="warning" class="addBtn" @click="correctProblem(homework.examId)" v-if="homework.states != 0" plain>
              查看考试情况
          </el-button>

          <el-button type="primary" class="addBtn" @click="editHomework(homework);" plain>
                <el-icon><Edit/></el-icon>
          </el-button>

            
        </el-collapse-item>    
    </el-collapse>
    </div>
  </el-scrollbar>
</template>

<script setup>
import { ref, onMounted } from "vue";
import $ from "jquery";
import { useRoute } from "vue-router";
import { ElMessage } from 'element-plus';

const Route = useRoute(); //获取到值
const courseId = ref("");

const editHomeworkForm = ref(false);
const addExamForm = ref(false);
const exams = ref();
const editHomeworkName = ref();
const editStartTime = ref();
const editStopTime = ref();
const editHomeworkId = ref();
const editExamTime = ref();



onMounted(() => {
  courseId.value = Route.params.courseId;
  puellExam();
});


const puellExam = () => {
    const token = localStorage.getItem("token");
    addExamForm.value = false;
    $.ajax({
        url: "http://124.222.105.205:5000/api/exam/PullExam",
        data: {
            courseId: courseId.value,
            type: 1
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
              exams.value = resp.data;
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
            console.log(resp.data);
        },
        error() {
            ElMessage({
                type: "error",
                message: "拉取考试失败",
            });
        },
    });
}

const addExam = () => {

    let examName = $("#examName").val();
    if (examName == "") {
        ElMessage({
          type: "error",
          message: "试卷名不能为空",
        });
        return false;
    }
    

    let startTime = $("#startTime").val();
    if (startTime == "") {
        ElMessage({
          type: "error",
          message: "开始时间不能为空",
        });
        return false;
    }

    let stopTime = $("#stopTime").val();
    if (stopTime == "") {
        ElMessage({
          type: "error",
          message: "结束时间不能为空",
        });
        return false;
    }

    

    if (stopTime < startTime) {
        ElMessage({
          type: "error",
          message: "结束时间不能小于开始时间",
        });
        return false;
    }

    let examTime = $("#examTime").val();
    if (examTime <= 0) {
      ElMessage({
          type: "error",
          message: "考试时间必须大于一分钟",
        });
        return false;
    }

    if (examTime >=1440) {
      ElMessage({
          type: "error",
          message: "考试时间必须小于24小时",
        });
        return false;
    }

    let subTime = Math.floor((new Date(stopTime) - new Date(startTime)) / 60000);



    if (examTime > subTime) {
      ElMessage({
          type: "error",
          message: "考试时长超过考试范围内时间！",
        });
        return false;
    }

    const token = localStorage.getItem("token");
    addExamForm.value = false;
    $.ajax({
        url: "http://124.222.105.205:5000/api/exam/addExam",
        data: {
            courseId: courseId.value,
            examName: examName,
            startTime: startTime,
            stopTime: stopTime,
            type: 1,
            examTime: examTime
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                puellExam();
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "添加考试失败",
            });
        },
    });

    
}

const editHomework = (homework) => {
  console.log(homework);
    editHomeworkForm.value = true;
    editHomeworkName.value = homework.examName;
    editStartTime.value = homework.startTime;
    editStopTime.value = homework.stopTime;
    editHomeworkId.value = homework.examId;
    editExamTime.value = homework.examTime;
}

const edithomeworkOk = () => {
    let examName = $("#editHomeworkName").val();
    if (examName == "") {
        ElMessage({
          type: "error",
          message: "试卷名不能为空",
        });
        return false;
    }

    let startTime = $("#editStartTime").val();
    if (startTime == "") {
        ElMessage({
          type: "error",
          message: "开始时间不能为空",
        });
        return false;
    }

    let stopTime = $("#editStopTime").val();
    if (stopTime == "") {
        ElMessage({
          type: "error",
          message: "结束时间不能为空",
        });
        return false;
    }

    if (stopTime < startTime) {
        ElMessage({
          type: "error",
          message: "结束时间不能小于开始时间",
        });
        return false;
    }
    
    let examTime = $("#editExamTime").val();
    if (examTime <= 0) {
      ElMessage({
          type: "error",
          message: "考试时间必须大于一分钟",
        });
        return false;
    }

    if (examTime >=1440) {
      ElMessage({
          type: "error",
          message: "考试时间必须小于24小时",
        });
        return false;
    }

    let subTime = Math.floor((new Date(stopTime) - new Date(startTime)) / 60000);



    if (examTime > subTime) {
      ElMessage({
          type: "error",
          message: "考试时长超过考试范围内时间！",
        });
        return false;
    }


    const token = localStorage.getItem("token");
    editHomeworkForm.value = false;
    $.ajax({
        url: "http://124.222.105.205:5000/api/exam/editExam",
        data: {
            examId: editHomeworkId.value,
            examName: examName,
            startTime: startTime,
            stopTime: stopTime,
            examTime: examTime
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                puellExam();
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改考试失败",
            });
        },
    });
}
const changeHomeworkState = (id, state) => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/homework/updateStates",
    data: {
      states: state,
      id: id,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }

      puellExam();
    },
    error() {
      ElMessage({
        type: "error",
        message: "修改考试状态失败",
      });
    },
  });
};

const deleteHomework = (id) => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/homework/deleteExam",
    data: {
      id: id,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }

      puellExam();
    },
    error() {
      ElMessage({
        type: "error",
        message: "删除失败",
      });
    },
  });
};

const gotoProblem = (id) => {
  const a = document.createElement('a');
  a.href = `/ProblemSetting/${id}/${courseId.value}/`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

const correctProblem = (id) => {
  const a = document.createElement('a');
  a.href = `/CorrectHomework/${id}/${courseId.value}/1/`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

</script>

<style scoped>

.addBtn {
    float: right;
    margin: 0px 5px;
}

</style>